(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("entitlements", [], factory);
	else if(typeof exports === 'object')
		exports["entitlements"] = factory();
	else
		root["entitlements"] = factory();
})(window, function() {
return 